import axios from 'axios';

export async function uploadFileToS3BR(file: File, url: string): Promise<void> {
  await axios.put(url, file, {
    headers: { 'Content-Type': file.type, 'Access-Control-Allow-Origin': '*' },
  });
}
